
<btn
  :href="url"
  as="a"
  kind="ebay"
  target="_blank"
  class="card-ebay-link"
>
  <span class="container">
    <span>Buy it now on</span>
    <img alt="eBay" :src="EbayLogo" />
  </span>
</btn>
